import Cookies from "js-cookie";
import { LOGIN, LOGIN_ERROR, LOGIN_LOADING, LOGIN_RET, LOGOUT, LOGOUT_CLR, LOGOUT_RET, REGISTER, REGISTER_ERROR, REGISTER_LOADING, REGISTER_RET, WHOAMI, WHOAMI_ERROR, WHOAMI_LOADING, WHOAMI_RET } from "../Constants";

const initialState = {
    isAuthenticated: false,
    user: null,

    login: false,
    loginRet: false,
    loginLoading: true,

    whoamiRet: false, 

    register: false,
    registerRet: false,
    registerLoading: false ,

    logout:false,
    logout_ret:false,
    logout_loading:false
}

export default function (state = initialState, action) {
    switch (action.type) {
        case LOGIN:
            return {   
                ...state,
                login: action.data,
                loginLoading: true
            }
        case LOGIN_RET:
            return {
                ...state,
                login: false,
                isAuthenticated: true,
                user: action.data.user,
                loginRet: action.data
            }
        case LOGIN_LOADING:
            return {
                ...state,
                loginRet: false,
                loginLoading: false
            }
        case WHOAMI:
            return {   
                ...state,
                loginLoading: true
            }
        case WHOAMI_RET:
            return {
                ...state,
                isAuthenticated: true,
                user: action.data.user,
                whoamiRet: action.data
            }
        case WHOAMI_LOADING:
            return {
                ...state,
                whoamiRet: false,
                loginLoading: false
            }
        case WHOAMI_ERROR:
        case LOGOUT:
        case LOGIN_ERROR:
        case REGISTER_ERROR: {
            Cookies.set("token_medical_auth", "")

            return {
                ...state,
                login: false,
                loginLoading: false,
                isAuthenticated: false,
                loginRet: false,
                whoamiRet: false,
                register: false,
                registerRet: false,
                registerLoading: false,
                user: null
            }
        }
        case REGISTER:
            return {   
                ...state,
                register: action.data,
                registerLoading: true
            }
        case REGISTER_RET:
            return {
                ...state,
                register: false,
                isAuthenticated: true,
                user: action.data.user,
                registerRet: action.data
            }
        case REGISTER_LOADING:
            return {
                ...state,
                registerRet: false,
                registerLoading: false
            }
        default: 
            return {
                ...state
            }
    }
}